import { ICON_DEFAULT_COLOR, ICON_DEFAULT_SIZE } from '@constants/icons';
import { IconProps } from '@models/icons';

function PhoneLine({ size = ICON_DEFAULT_SIZE, color = ICON_DEFAULT_COLOR, ...rest }: IconProps) {
    return (
        <svg width={size} height={size} viewBox="0 0 31 30" fill="none" xmlns="http://www.w3.org/2000/svg"
            {...rest} >
            <path d="M20.4561 5.76172C21.1342 5.76176 21.7381 6.33384 21.7383 7.08594V22.9141C21.7381 23.6761 21.1652 24.2382 20.4561 24.2383H11.5439C10.8348 24.2382 10.2619 23.6761 10.2617 22.9141V7.08594C10.2619 6.41629 10.7655 5.86111 11.4023 5.77246L11.5322 5.76172H20.4561Z"
                stroke={color}
                strokeWidth="1.52381"
                strokeLinecap="round"/>
        </svg>
    );
}

export default PhoneLine;
